const checkFile = /_\d{13}$/;

export function renameFile(file: File, newName: string): File {
  return new File([file], newName, {
    type: file.type,
    lastModified: file.lastModified,
  });
}

/**
 * Removes timestamp suffix from a filename if present.
 *
 * @param filename - The filename to beautify.
 * @returns The filename without a timestamp suffix.
 */
export function beautifyFilename(filename: string): string {
  return checkFile.test(filename) ? filename.replace(checkFile, "") : filename;
}
